import { useLocation, useNavigate } from 'react-router-dom';
import OnboardContent from '../onboarding/OnboardContent';
import { Flex } from 'antd';
import { useNavigation } from '../../context/NavigationContext';
import { useTranslation } from 'react-i18next';
import { useAuthenticationProvider } from '../../authentication/authProvider';
import { Button } from '../Ant';
import { Logout } from '../icons';
import LoggedUser from '../onboarding/loggedUser';
import { useUser } from '../../context/UserContext';
import { IAccountProfile } from '../../interface/user';
import { usePage } from '../../context/PageContext';
import { useEffect } from 'react';
import { ErrorType } from '../../interface/errorTypes';
import { TFunction } from 'i18next';

const getErrorMessageContent = (errorType: string | null, t: TFunction) => {
  switch (errorType) {
    case ErrorType.VendorForbidden:
      return {
        title: t('common:applicationForbidden'),
        subTitle: t('common:applicationForbiddenMessage', { appName: 'CSI MyOutlook' }),
      };
    case ErrorType.UserForbidden:
      return {
        title: t('common:userForbidden'),
        subTitle: t('common:userForbiddenMessage'),
      };
    default:
      return {
        title: t('common:accessForbidden'),
        subTitle: t('common:accessForbiddenUnknownReason'),
      };
  }
};

const AccessForbidden = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { lastPage } = useNavigation();
  const { user } = useUser();
  const { setTitle } = usePage();
  const { logout } = useAuthenticationProvider();

  const handleRetry = () => {
    navigate(lastPage);
  };

  useEffect(() => {
    setTitle(t('common:accessForbidden'));
  }, []);

  const getErrorMessage = () => {
    const errorType = location?.state?.errorType || sessionStorage.getItem('forbiddenErrorType');
    return getErrorMessageContent(errorType, t);
  };

  const handleLogout = () => {
    // Clear the error before logging out
    sessionStorage.removeItem('forbiddenErrorType');
    logout();
  };

  const { title, subTitle } = getErrorMessage();

  return (
    <div className="d-flex justify-center flex-col items-center h-full pb-gutter">
      {user?.email && <LoggedUser user={user as unknown as IAccountProfile} />}
      <OnboardContent
        icon={<img src="../../assets/icons/notallowed.svg" alt="Not allowed" />}
        title={title}
        subtitle={subTitle}
      />
      <Flex className="w-full" align="center" gap={5}>
        <Button
          data-testid="logout-button"
          icon={<Logout />}
          onClick={handleLogout}
          size="large"
          block
          maxwidth="120px"
          className="logout-btn"
        >
          {t('common:logout')}
        </Button>
        <Button data-testid="retry-button" type="primary" onClick={handleRetry} size="large" block>
          {t('common:retry')}
        </Button>
      </Flex>
    </div>
  );
};

export default AccessForbidden;
